import { Link } from "react-router-dom";

const friendLinks = [
  { label: "日剧推荐", to: "/category/series" },
  { label: "日本电影", to: "/category/movie" },
  { label: "热门排行", to: "/" },
  { label: "关于我们", to: "/about" },
];

export default function SiteFooter() {
  return (
    <footer className="mt-16 border-t border-background-200 bg-secondary-900 pb-24 text-background-200 md:pb-0">
      <div className="mx-auto w-full px-4 py-12 md:px-8">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          <div className="sm:col-span-2">
            <Link to="/" className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-movie-2-line text-xl" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50">
                日本在线观看
              </span>
            </Link>
            <p className="mt-3 max-w-md text-sm leading-relaxed text-background-300/90">
              专注提供丰富的日本电影、电视剧资源介绍，涵盖热门日剧和电影内容，方便用户浏览剧情简介与影像信息、轻松追剧。本站内容均为示范性质，仅供学习交流。
            </p>
          </div>

          <div>
            <h3 className="mb-3 font-heading text-sm font-bold text-background-50">
              快捷导航
            </h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/" className="transition-colors hover:text-accent-400">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category/movie" className="transition-colors hover:text-accent-400">
                  电影频道
                </Link>
              </li>
              <li>
                <Link to="/category/series" className="transition-colors hover:text-accent-400">
                  电视剧频道
                </Link>
              </li>
              <li>
                <Link to="/about" className="transition-colors hover:text-accent-400">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="mb-3 font-heading text-sm font-bold text-background-50">
              友情链接
            </h3>
            <ul className="space-y-2 text-sm">
              {friendLinks.map((link) => (
                <li key={link.label}>
                  <Link to={link.to} className="transition-colors hover:text-accent-400">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-start justify-between gap-3 border-t border-background-500/20 pt-6 text-xs text-background-400 sm:flex-row sm:items-center">
          <p>© 2026 日本在线观看 · 本站影视内容均为虚构示范数据</p>
          <p>仅供演示 · 不含真实播放与下载服务</p>
        </div>
      </div>
    </footer>
  );
}